import React from 'react'
import PropTypes from 'prop-types'
import ContentWarningIcon from '../mini/ContentWarningIcon'

const ContentWarningsEditor = ({
  contentWarnings,
  handleContentWarningClick
}) => (
  <div className="content-warnings-container-wrapper">
    <div className="content-warnings-container">
      <div className="content-warning-row">
        <div className="content-warning-type">Graphic Content</div>
        <input
          id="graphicContent"
          type="checkbox"
          checked={
            contentWarnings &&
            contentWarnings.graphic_content &&
            contentWarnings.graphic_content !== null &&
            contentWarnings.graphic_content.value === 'graphic_content'
          }
          value={'graphic_content'}
          name="graphic_content"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="graphicContent">
          <ContentWarningIcon abbrev={'GC'} />
          Graphic Content
        </label>
      </div>

      <div className="content-warning-row">
        <div className="content-warning-type">Language</div>
        <input
          id="languageModerate"
          type="radio"
          checked={
            contentWarnings &&
            contentWarnings.language &&
            contentWarnings.language !== null &&
            contentWarnings.language.value === 'moderate'
          }
          value={'moderate'}
          name="language"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="languageModerate">
          <ContentWarningIcon abbrev={'L'} />
          Moderate
        </label>
        <input
          id="languageExplicit"
          type="radio"
          checked={
            contentWarnings &&
            contentWarnings.language &&
            contentWarnings.language !== null &&
            contentWarnings.language.value === 'explicit'
          }
          value={'explicit'}
          name="language"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="languageExplicit">
          <ContentWarningIcon abbrev={'xL'} />
          Explicit
        </label>
        <input
          id="languageNone"
          type="radio"
          checked={contentWarnings && contentWarnings.language === null}
          value={''}
          name="language"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="languageNone">None</label>
      </div>

      <div className="content-warning-row">
        <div className="content-warning-type">Violence</div>
        <input
          id="violenceModerate"
          type="radio"
          checked={
            contentWarnings &&
            contentWarnings.violence &&
            contentWarnings.violence !== null &&
            contentWarnings.violence.value === 'moderate'
          }
          value={'moderate'}
          name="violence"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="violenceModerate">
          <ContentWarningIcon abbrev={'V'} />
          Moderate
        </label>
        <input
          id="violenceExplicit"
          type="radio"
          checked={
            contentWarnings &&
            contentWarnings.violence &&
            contentWarnings.violence !== null &&
            contentWarnings.violence.value === 'explicit'
          }
          value={'explicit'}
          name="violence"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="violenceExplicit">
          <ContentWarningIcon abbrev={'xV'} />
          Explicit
        </label>
        <input
          id="violenceNone"
          type="radio"
          checked={contentWarnings && contentWarnings.violence === null}
          value={''}
          name="violence"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="violenceNone">None</label>
      </div>

      <div className="content-warning-row">
        <div className="content-warning-type">Sexual Themes</div>
        <input
          id="sexual_themesModerate"
          type="radio"
          checked={
            contentWarnings &&
            contentWarnings.sexual_themes &&
            contentWarnings.sexual_themes !== null &&
            contentWarnings.sexual_themes.value === 'moderate'
          }
          value={'moderate'}
          name="sexual_themes"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="sexual_themesModerate">
          <ContentWarningIcon abbrev={'S'} />
          Moderate
        </label>
        <input
          id="sexual_themesExplicit"
          type="radio"
          checked={
            contentWarnings &&
            contentWarnings.sexual_themes &&
            contentWarnings.sexual_themes !== null &&
            contentWarnings.sexual_themes.value === 'explicit'
          }
          value={'explicit'}
          name="sexual_themes"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="sexual_themesExplicit">
          <ContentWarningIcon abbrev={'xS'} />
          Explicit
        </label>
        <input
          id="sexual_themesNone"
          type="radio"
          checked={contentWarnings && contentWarnings.sexual_themes === null}
          value={''}
          name="sexual_themes"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="sexual_themesNone">None</label>
      </div>

      <div className="content-warning-row">
        <div className="content-warning-type">Risky Behavior</div>
        <input
          id="smoking"
          type="checkbox"
          checked={
            contentWarnings &&
            contentWarnings.risky_behaviors &&
            contentWarnings.risky_behaviors.some(e => e.value === 'smoking')
          }
          value={'smoking'}
          name="risky_behaviors"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="smoking">
          <ContentWarningIcon abbrev={'Sm'} />
          Smoking
        </label>
        <input
          id="drugUse"
          type="checkbox"
          checked={
            contentWarnings &&
            contentWarnings.risky_behaviors &&
            contentWarnings.risky_behaviors.some(e => e.value === 'drug_use')
          }
          value={'drug_use'}
          name="risky_behaviors"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="drugUse">
          <ContentWarningIcon abbrev={'D'} />
          Drug Use
        </label>
        <input
          id="alcohol"
          type="checkbox"
          checked={
            contentWarnings &&
            contentWarnings.risky_behaviors &&
            contentWarnings.risky_behaviors.some(e => e.value === 'alcohol')
          }
          value={'alcohol'}
          name="risky_behaviors"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="alcohol">
          <ContentWarningIcon abbrev={'A'} />
          Alcohol
        </label>
        <input
          id="other"
          type="checkbox"
          checked={
            contentWarnings &&
            contentWarnings.risky_behaviors &&
            contentWarnings.risky_behaviors.some(e => e.value === 'other')
          }
          value={'other'}
          name="risky_behaviors"
          onClick={handleContentWarningClick}
        />
        <label htmlFor="other">
          <ContentWarningIcon abbrev={'O'} />
          Other
        </label>
      </div>
    </div>
  </div>
)

ContentWarningsEditor.propTypes = {
  contentWarnings: PropTypes.object,
  handleContentWarningClick: PropTypes.func.isRequired
}

export default ContentWarningsEditor



// WEBPACK FOOTER //
// ./src/components/quest/ContentWarningsEditor.js